export default {
  title: '职位列表',
  label: {
    all: '全选',
    totalCount: '搜索结果',
    selected: '选中',
    date: '日期',
    refresh: '刷新职位发布时间',
    postToAgency: '发布至猎头',
    setReferral: '设置推荐奖励规则',
    generateSiteShare: '生成职业主页链接/二维码',
    generateJobShare: '生成职位链接/二维码',
    generateMobileShare: '生成手机职位列表链接/二维码',
    closeJob: '关闭职位',
    addCandidate: '添加单个求职者',
    batchAddCandidate: '添加多个求职者（批量）',
    new: '未读',
    total: '所有',
    screen: '筛选',
    interview: '面试',
    offer: 'Offer',
    hired: '雇佣',
    leads: '潜在',
    openDays: '开放天数',
    jobTitle: '职位名称',
    recruiter: '创建人/协作者',
    disabledRecruiter: '创建人/协作者（已禁用）',
    jobLocation: '职位地点',
    jobStatus: {
      label: '职位状态',
      OPEN: '开放的职位',
      CLOSED: '关闭的职位',
      all: '所有职位',
      HOT: '热门职位',
      ON_HOT: '暂停的职位',
      CANCEL: '取消的职位'
    },
    myJobs: '我的职位',
    allJobs: '所有职位',
    postTo: '发布至',
    postHistory: '发布历史',
    putAway: '展开',
    shareToAgency: '发布至猎头',
    shareDialogTitle: '直接生成链接/二维码或者添加追踪代码名称和明细，用于追踪申请来源渠道',
    sourceName: '追踪代码名称 （例如Job Fair或者Hiring Campaign等，建议用英文）',
    sourceDetail: '追踪代码明细 （例如招聘会日期，活动名称等，建议用英文）',
    simpleSourceName: '追踪代码名称:',
    simpleCodeName: '追踪代码明细:',
    jobInfo: '职位信息',
    company: '公司',
    postTaskTime: '开始时间',
    postTaskStatus: '状态',
    postTaskFinishTime: '完成时间',
    finished: '已完成',
    inProgress: '进行中',
    openJobDetail: '查看职位详情',
    includeChildrenCompany: '包含子公司',
    postChannel: '发布渠道',
    defaultChannelName: '微信/职位主页',
    selectChannelAccount: '选择渠道账号'
  },
  tips: {
    pageViews: '页面浏览量',
    share: '分享',
    more: '更多',
    hotJob: '热门职位',
    editJob: '编辑职位',
    addJob: '添加职位',
    closeJob: '关闭职位',
    openJob: '开启职位',
    draft: '推荐设置（草稿）',
    pending: '推荐设置（审核中）',
    approve: '推荐设置已生效',
    rejected: '推荐设置（拒绝）',
    archived: '推荐设置（存档）',
    jobClosed: '职位已关闭。如果想发布此职位到招聘渠道，请修改职位关闭日期和职位状态到开放'
  },
  btn: {
    action: '操作',
    publish: '发布',
    yes: '确认',
    cancel: '取消',
    channelDialog: {
      add: '自动发布',
      update: '更新',
      hide: '隐藏',
      unPublish: '关闭',
      cancel: '取消',
      view: '查看',
      manualAdd: '手动发布'
    },
    agencyDialog: {
      sendEmailCreator: '猎头上传简历邮件提醒职位创建人',
      sendEmailCoordinator: '猎头上传简历邮件提醒职位协作者'
    },
    shareDialog: {
      download: '下载',
      cancel: '取消',
      copyUrl: '复制链接',
      createQRCode: '生成二维码'
    }
  },
  placeholder: {
    agency: '请选择猎头',
    agencyName: '姓名'
  },
  message: {
    hasNoPermission: '您没有权限进行相关操作，请联系你的AJINGA管理员或者客户成功顾问获取支持。',
    jobCountNoEnough: '您不能创建更多职位，请联系你的AJINGA管理员或者客户成功顾问获取支持。',
    channelAlreadyAction: '已发布在{channelName}',
    channelReadyPost: '正在发布到{channelName}',
    channelReadyClose: '正在从{channelName}关闭',
    channelReadyRefresh: '正在{channelName}上刷新',
    confirmAction: '确认操作?',
    channelPostProcessing: '系统后台正在处理上次发布请求，请等待系统完成上次发布后再进行更新操作。',
    notFoundPostingChannel: '找不到想发布的渠道？请联系你的AJINGA管理员或者客户成功顾问获取支持。',
    shareDialogTitleTip: '当一个候选人通过已标记的链接或者二维码申请，菁客可以追踪这个申请并记录来源渠道，这样可以帮助您更好的了解渠道有效性。<br/><br/>追踪代码名称一般是你用于推广的渠道名称，例如招聘会或者招聘活动（建议用英文）<br/><br/>如果你需要多个链接来追踪相似的渠道信息，您可以添加具体的渠道细节在追踪代码明细中，例如，追踪代码名称是招聘会，那么追踪代码明细可以是招聘会的日期或者具体名称例如2024春招，再例如，追踪代码名称是招聘活动，追踪代码明细可以是微信朋友圈广告20240715（建议用英文）',
    sourceNameTip: '不是所有的用户都能新建追踪代码名称，如果你无法看到你想用的追踪代码名称也不能新建，请联系你的AJINGA管理员或者客户成功顾问获取支持。',
    sourceDetailTip: '不是所有的用户都能新建追踪代码明细，如果你无法看到你想用的追踪代码明细也不能新建，请联系你的AJINGA管理员或者客户成功顾问获取支持。',
    copyURLTip: '请按CTRL+C复制地址',
    selectAtLeastJob: '请选择一个职位',
    refreshSuccess: '职位刷新成功',
    closeJobTip: '确认批量关闭{count}个职位？',
    closeOneJobTip: '确认关闭该职位？',
    refreshJobTip: '确认批量刷新{count}个职位的发布日期？',
    refreshOneJobTip: '确认刷新该职位的发布日期？',
    cancelAction: '操作已取消',
    closingTips: '正在关闭职位，关闭完成后将刷新职位列表!',
    closingSuccess: '职位关闭成功!',
    postingJobTips: '正在创建相关任务，请稍候',
    postingJobSuccess: '你的任务已成功提交',
    setHotJobTips: '正在设置热门职位，请稍候',
    setHotJobSuccess: '设置热门职位成功',
    closeHotJobSuccess: '取消热门职位成功',
    deleteSuccess: '删除成功',
    closeJobSuccess: '职位关闭成功',
    openJobSuccess: '职位开启成功',
    jobChannelChange: '职位发布信息变更，刷新职位信息，请稍候',
    postToAgencySuccess: '你的职位已经成功发布至猎头',
    postToAgencyEmpty: '没有职位需要发布给猎头，只能发布开放的职位',
    optionSuccess: '操作成功',
    notAllowApplication: '您无法查看该职位的候选人，请联系你的AJINGA管理员或者客户成功顾问获取支持。'
  }
}
